"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dialogSlice = dialogSlice;
const getDialogInitialState = () => ({
    alert: {
        message: '',
        type: 'info',
        open: false,
        actionText: 'OK',
        showCancel: false,
        onAccept: () => ({}),
    },
});
const dialogInitialState = {
    dialog: getDialogInitialState(),
};
function dialogSlice(set) {
    return {
        ...dialogInitialState,
        setDialog(alert) {
            set((state) => {
                state.dialog.alert = alert;
                return state;
            }, false, '[setDialog]');
        },
        closeDialog() {
            set((state) => {
                state.dialog.alert.open = false;
                return state;
            }, false, '[closeDialog]');
        },
        resetDialog() {
            set((state) => {
                state.dialog = getDialogInitialState();
                return state;
            }, false, '[resetDialog]');
        },
    };
}
